import { useState, useEffect } from 'react';
import config from '../../../config/config';
import { FaPrint, FaTrash, FaChevronLeft, FaChevronRight, FaSearch, FaPencilRuler, FaPenAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export function ViewShare() {
  const [shares, setShares] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [filteredShares, setFilteredShares] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();

  // Category aur Subcategory (Type) ke liye alag search states
  const [columnSearch, setColumnSearch] = useState({
    customer_id: '',
    firstname: '',
    cat_name: '',    // Category (e.g. Cow)
    subcat_name: '', // Type/Sub-Category (e.g. Welfare)
    slaughtering_day: '',
    animal_number: '',
    share_number: '',
    created_at: ''
  });

  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    fetchAllShares();
  }, []);

  useEffect(() => {
    const filtered = shares.filter(share => {
      const matchesId = String(share.customer_id || '').toLowerCase().includes(columnSearch.customer_id.toLowerCase());
      const matchesName = String(share.firstname || '').toLowerCase().includes(columnSearch.firstname.toLowerCase()) ||
        String(share.phone || '').includes(columnSearch.firstname);

      // Alag-alag filtering logic
      const matchesCat = String(share.cat_name || '').toLowerCase().includes(columnSearch.cat_name.toLowerCase());
      const matchesSubCat = String(share.subcat_name || '').toLowerCase().includes(columnSearch.subcat_name.toLowerCase());

      const matchesDay = columnSearch.slaughtering_day === '' || String(share.slaughtering_day) === columnSearch.slaughtering_day;
      const matchesAnimal = String(share.animal_number || '').includes(columnSearch.animal_number);
      const matchesShare = String(share.share_number || '').includes(columnSearch.share_number);
      const matchesDate = (() => {
        if (!columnSearch.created_at) return true;

        // Database ki date ko readable format (DD/MM/YYYY) mein convert karein
        const formattedDate = new Date(share.created_at).toLocaleDateString('en-GB');

        // User jo search kar raha hai usay format karein (space wagaira khatam karne ke liye)
        const searchVal = columnSearch.created_at.trim();

        // "Includes" ki jagah check karein ke kya date user ki search se start ho rahi hai
        // Is se time (11:00) wala masla hal ho jayega
        return formattedDate.includes(searchVal);
      })();


      return matchesId && matchesName && matchesCat && matchesSubCat && matchesDay && matchesAnimal && matchesShare && matchesDate;
    });
    setFilteredShares(filtered);
    setCurrentPage(1);
  }, [shares, columnSearch]);

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setColumnSearch(prev => ({ ...prev, [name]: value }));
  };

  const fetchAllShares = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${config.baseUrl}/api/moderator/all-shares`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Failed to fetch shares');
      const data = await response.json();
      setShares(data);
    } catch (err) {
      setError('Failed to load shares');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // handlePrint aur handleDelete functions wahi rahengi jo pehle thin...
  const handlePrint = async (id, shareId) => {
    try {
      const response = await fetch(`${config.baseUrl}/api/moderator/generate-slip/${id}/${shareId}`);
      if (!response.ok) throw new Error('Fetch failed');
      const paymentData = await response.json();
      localStorage.setItem('temp_slip_data', JSON.stringify(paymentData));
      window.open('/slip', '_blank');
    } catch (error) {
      console.error('Error fetching/saving data:', error);
    }
  };

  const handleDelete = async (share) => {
    if (!window.confirm("Are you sure? You want to Delete this Share?")) return;
    try {
      const response = await fetch(`${config.baseUrl}/api/qurbani/cancel-share/${share.share_id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          animal_number: share.animal_number,
          share_number: share.share_number,
          slaughtering_day: share.slaughtering_day,
          type: share.cat_id,
          refundAmount: share.share_price,
          category: share.sub_id,
          userId: `${userId}`
        })
      });
      if (!response.ok) throw new Error('Delete karne mein masla hua');
      alert('Share Deleted Successfully');
      fetchAllShares();
    } catch (error) {
      alert(error.message);
    }
  };
  const handleEdit = async (id) => {
    navigate(`/moderator/Edit/${id}`);
  }

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentEntries = filteredShares.slice(indexOfFirstEntry, indexOfLastEntry);
  const totalPages = Math.ceil(filteredShares.length / entriesPerPage);

  return (
    <main className="flex-1 p-4 bg-indigo-100 min-h-screen">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-2xl font-extrabold text-indigo-800">Ijtimai Qurbani Shares</h1>
        <div className="flex items-center bg-white border border-gray-200 rounded-lg px-3 py-2 shadow-sm">
          <span className="text-gray-400 text-sm mr-2 font-medium">Show</span>
          <select
            className="bg-transparent font-bold text-gray-700 focus:outline-none cursor-pointer"
            value={entriesPerPage}
            onChange={(e) => setEntriesPerPage(Number(e.target.value))}
          >
            {[10, 25, 50, 100].map(val => <option key={val} value={val}>{val}</option>)}
          </select>
        </div>
      </div>

      <div className="bg-white rounded-md shadow-lg border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-indigo-900 text-white uppercase text-[11px] tracking-wider">
                <th className="px-2 py-2 font-bold text-center">ID</th>
                <th className="px-2 py-2 font-bold">Person</th>
                <th className="px-2 py-2 font-bold">Category</th>
                <th className="px-2 py-2 font-bold">Type</th>
                <th className="px-2 py-2 font-bold text-center">Day</th>
                <th className="px-2 py-2 font-bold text-center">Animal No</th>
                <th className="px-2 py-2 font-bold text-center">Share No</th>
                <th className="px-2 py-2 font-bold text-center">Date</th>
                <th className="px-2 py-2 font-bold text-center">Actions</th>
              </tr>
              {/* Search Row */}
              <tr className="bg-indigo-50 border-b border-indigo-100">
                <td className="px-2 py-2">
                  <input name="customer_id" value={columnSearch.customer_id} onChange={handleSearchChange}
                    placeholder="ID..." className="w-full px-2 py-1 text-xs border rounded outline-none focus:ring-1 focus:ring-indigo-400" />
                </td>
                <td className="px-2 py-2">
                  <input name="firstname" value={columnSearch.firstname} onChange={handleSearchChange}
                    placeholder="Search..." className="w-full px-2 py-1 text-xs border rounded outline-none focus:ring-1 focus:ring-indigo-400" />
                </td>
                <td className="px-2 py-2">
                  <input name="cat_name" value={columnSearch.cat_name} onChange={handleSearchChange}
                    placeholder="Cow/Goat..." className="w-full px-2 py-1 text-xs border rounded outline-none focus:ring-1 focus:ring-indigo-400" />
                </td>
                <td className="px-2 py-2">
                  <input name="subcat_name" value={columnSearch.subcat_name} onChange={handleSearchChange}
                    placeholder="Welfare..." className="w-full px-2 py-1 text-xs border rounded outline-none focus:ring-1 focus:ring-indigo-400" />
                </td>
                <td className="px-2 py-2 text-center">
                  <select name="slaughtering_day" value={columnSearch.slaughtering_day} onChange={handleSearchChange}
                    className="w-full px-2 py-1 text-xs border rounded outline-none cursor-pointer">
                    <option value="">All</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>
                <td className="px-2 py-2">
                  <input name="animal_number" value={columnSearch.animal_number} onChange={handleSearchChange}
                    placeholder="No..." className="w-full px-1 py-1 text-xs border rounded outline-none text-center" />
                </td>
                <td className="px-2 py-2">
                  <input name="share_number" value={columnSearch.share_number} onChange={handleSearchChange}
                    placeholder="No..." className="w-full px-1 py-1 text-xs border rounded outline-none text-center" />
                </td>
                <td className="px-2 py-2">
                  <input name="created_at" value={columnSearch.created_at} onChange={handleSearchChange}
                    placeholder="eg. 10/05/2026" className="w-full px-1 py-1 text-xs border rounded outline-none text-center" />
                </td>
                <td className="bg-indigo-50"></td>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-100">
              {loading ? (
                <tr>
                  <td colSpan="8" className="py-20 text-center text-gray-400 font-medium italic">
                    Loading data...
                  </td>
                </tr>
              ) : currentEntries.length > 0 ? (
                currentEntries.map((share, index) => (
                  <tr key={index} className="hover:bg-indigo-100/50 transition-colors">
                    <td className="px-2 py-2 text-center">
                      <span className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs font-bold">
                        {share.customer_id}
                      </span>
                    </td>
                    <td className="px-2 py-2">
                      <div className="text-[10px] font-bold text-gray-800">{share.firstname}</div>
                      <div className="text-[10px] text-center text-indigo-600">{share.phone}</div>
                    </td>
                    <td className="px-2 py-2 text-center">
                      <span className="text-gray-700 font-bold text-sm ">{share.cat_name}</span>
                    </td>
                    <td className="px-2 py-2">
                      <span className="text-gray-500 text-xs font-bold italic">{share.subcat_name}</span>
                    </td>
                    <td className="px-2 py-2">
                      <span className="px-2 py-2 rounded-full bg-indigo-100 text-indigo-700 text-xs font-black">
                        DAY {share.slaughtering_day}
                      </span>
                    </td>
                    <td className="px-2 py-2 text-center text-xs font-bold text-orange-700">{share.animal_number || '-'}</td>
                    <td className="px-2 py-2 text-center text-xs font-bold text-purple-700">{share.share_number || '-'}</td>
                    <td className="px-2 py-2 font-semibold text-xs text-gray-800">
                      {new Date(share.created_at).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                      })}
                      <span className="text-gray-400 ml-2">
                        {new Date(share.created_at).toLocaleTimeString('en-US', {
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </span>
                    </td>
                    <td className="px-2 py-2">
                      <div className="flex justify-center gap-2">
                        <button onClick={() => handleEdit(share.customer_id)} className="p-2 bg-yellow-500 text-white rounded hover:bg-yellow-700 shadow-sm"><FaPenAlt size={12} /></button>
                        <button onClick={() => handlePrint(share.id, share.share_id)} className="p-2 bg-indigo-700 text-white rounded hover:bg-indigo-800 shadow-sm"><FaPrint size={12} /></button>
                        <button onClick={() => handleDelete(share)} className="p-2 bg-red-600 text-white rounded hover:bg-red-700 shadow-sm"><FaTrash size={12} /></button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="py-20 text-center text-gray-500 font-medium">No records found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Logic */}
        <div className="p-5 bg-gray-50 border-t flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            Showing <span className="font-bold">{filteredShares.length > 0 ? indexOfFirstEntry + 1 : 0}</span> to <span className="font-bold">{Math.min(indexOfLastEntry, filteredShares.length)}</span> of <span className="font-bold">{filteredShares.length}</span>
          </p>
          <nav className="flex items-center gap-2">
            <button disabled={currentPage === 1} onClick={() => setCurrentPage(prev => prev - 1)} className="p-2 border rounded bg-white disabled:opacity-30"><FaChevronLeft size={12} /></button>
            <div className="flex font-bold text-xs">
              <span className="px-3 py-1 bg-indigo-700 text-white rounded-l">{currentPage}</span>
              <span className="px-3 py-1 bg-white border border-l-0 text-gray-700 rounded-r">{totalPages || 1}</span>
            </div>
            <button disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(prev => prev + 1)} className="p-2 border rounded bg-white disabled:opacity-30"><FaChevronRight size={12} /></button>
          </nav>
        </div>
      </div>
    </main>
  );
}